// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientVaccinationRequest } from './patient-vaccination-request';

/** See com.rev360.pms.api.controller.patient.immunization.CreatePatientVaccinationRequest */
/* istanbul ignore next */
@GandalfModel
export class CreatePatientVaccinationRequest extends PatientVaccinationRequest {

	@GandalfLabel('Administered Amount')
	@GandalfProperty({ designType: Number })
	administeredAmount!: number | null;

	@GandalfLabel('Administered Amount Unit')
	@GandalfProperty({ designType: Number })
	administeredAmountUnitId!: number | null;

	@GandalfLabel('Administered At')
	@GandalfProperty({ designType: Number })
	administeredAtLocationId!: number | null;

	@GandalfLabel('Administered By')
	@GandalfProperty({ designType: Number })
	administeredByEmployeeId!: number | null;

	@GandalfLabel('Administered On')
	@GandalfProperty({ designType: Date })
	administeredOn!: Date | null;

	@GandalfLabel('Administered Route')
	@GandalfProperty({ designType: Number })
	administeredRouteId!: number | null;

	@GandalfLabel('Administered Site')
	@GandalfProperty({ designType: Number })
	administeredSiteId!: number | null;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('CVX Code')
	@GandalfValidator({ notNull: { message: 'CVX Code is required' } })
	@GandalfValidator({ sizeString: { min: 1, max: 20, message: 'CVX Code must be between 1 and 20 characters' } })
	@GandalfProperty({ designType: String, isRequired: true })
	cvxDetailCode!: string;

	@GandalfLabel('End Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	endDate!: Date | null;

	@GandalfLabel('Not Given')
	@GandalfProperty({ designType: Boolean })
	notGiven!: boolean | null;

	@GandalfLabel('Reason')
	@GandalfProperty({ designType: Number })
	notGivenReasonId!: number | null;

	@GandalfLabel('Ordered By')
	@GandalfProperty({ designType: Number })
	orderedByProviderId!: number | null;

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfLabel('Substance Expiration Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	substanceExpireDate!: Date | null;

	@GandalfLabel('Substance Lot')
	@GandalfValidator({ sizeString: { message: 'Substance Lot cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	substanceLot!: string | null;

	@GandalfLabel('Substance Manufacturer')
	@GandalfValidator({ sizeString: { min: 1, max: 255, message: 'Substance Manufacturer must be between 1 and 255 characters' } })
	@GandalfProperty({ designType: String })
	substanceManufacturerId!: string | null;

}
